import { z } from 'zod';

export const ConfigsSchema = z.object({
  simplr: z.object({
    flowSystemId: z.string().optional(),
    widgetId: z.string(),
    showStateDebugger: z.boolean().optional(),
    moreTicketInfo: z.record(z.string(), z.unknown()).optional(),
    trackingParameters: z.record(z.string(), z.string()).optional(),
  }),
  parentElementId: z.string().optional(),
  language: z.string().optional(),
});

export type Configs = z.infer<typeof ConfigsSchema>;
